var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":(val) => _vm.$emit('input', val)}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value,"disabled":item.disabled}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }